module.exports = __webpack_public_path__ + "img/vacation.fcdb4eef.png";